import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/born-to-trade-podcast-contents/TopicOne";

const BornToTradePodcastContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Your Weekly Dose of Trading Intelligence</h2>
                <p>
                  The Born to Trade Podcast by The Pips brings together
                  analysts, industry professionals, and successful traders to
                  decode the latest market trends, discuss trading psychology,
                  and share actionable strategies. From Forex and Crypto to
                  Stocks and Commodities, each episode offers insights designed
                  to keep you informed, inspired, and ready for your next big
                  move. You’ll gain practical knowledge you can apply
                  immediately, whether you're refining your strategy or
                  exploring new market opportunities. With fresh perspectives
                  and real-world experiences, the podcast becomes your go-to
                  source for continuous growth as a trader.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Explore Episodes
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/born_to_trade_podcast/born_to_trade_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BornToTradePodcastContentOne;
